import React from "react";
import { Modal, Button, type ButtonProps } from "antd";

type Align = "left" | "center" | "right";

type AppModalProps = {
  open: boolean;
  title?: string;
  icon?: React.ReactNode;
  description?: string | React.ReactNode;
  subDescription?: string;

  // Footer & butonat
  showCancel?: boolean;
  showConfirm?: boolean;
  cancelText?: string;
  confirmText?: string;
  confirmType?: ButtonProps["type"]; // "default" | "primary" | "dashed" | "link" | "text"
  danger?: boolean;
  ghost?: boolean;
  loading?: boolean;
  confirmButtonProps?: ButtonProps; // props ekstra për butonin e konfirmimit
  cancelButtonProps?: ButtonProps; // props ekstra për butonin e cancel
  footerAlign?: Align; // default: center
  footer?: React.ReactNode; // nëse kalon këtë, override i plotë

  // Ngjarje
  onCancel: () => void;
  onConfirm?: () => void | Promise<void>;
  afterClose?: () => void;

  // Modal props
  width?: number;
  className?: string;
  closable?: boolean;
  centered?: boolean;
  maskClosable?: boolean;

  children?: React.ReactNode;
};

const AppModal: React.FC<AppModalProps> = ({
  open,
  onCancel,
  onConfirm,
  afterClose,
  title,
  icon,
  description,
  subDescription,

  showCancel = true,
  showConfirm,
  cancelText = "Cancel",
  confirmText = "Confirm",
  confirmType = "primary",
  danger = false,
  ghost = false,
  loading = false,
  confirmButtonProps,
  cancelButtonProps,
  footerAlign = "center",
  footer,

  width = 480,
  className,
  closable = true,
  centered = true,
  maskClosable = false,
  children,
}) => {
  const shouldShowConfirm = showConfirm ?? Boolean(onConfirm);

  const defaultFooter = (
    <div
      className="modal-footer"
      style={{
        display: "flex",
        justifyContent:
          footerAlign === "left"
            ? "flex-start"
            : footerAlign === "right"
            ? "flex-end"
            : "center",
        gap: 12,
      }}
    >
      {showCancel && (
        <Button onClick={onCancel} {...cancelButtonProps}>
          {cancelText}
        </Button>
      )}
      {shouldShowConfirm && (
        <Button
          type={confirmType}
          danger={danger}
          ghost={ghost}
          loading={loading}
          onClick={onConfirm}
          {...confirmButtonProps}
        >
          {confirmText}
        </Button>
      )}
    </div>
  );

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      afterClose={afterClose}
      footer={footer ?? defaultFooter}
      closable={closable}
      centered={centered}
      maskClosable={maskClosable}
      width={width}
      destroyOnClose
      className={className}
    >
      {(title || icon) && (
        <div className="modal-header">
          {icon}
          {title && (
            <h3
              style={{
                margin: 0,
                fontSize: 22,
                fontWeight: 600,
                color: "#4A1C96",
                textAlign: "center",
                fontFamily: "Poppins",
              }}
            >
              {title}
            </h3>
          )}
        </div>
      )}

      {description && (
        <p
          style={{
            margin: 0,
            textAlign: "center",
            color: "unset",
            fontSize: 16,
            fontFamily: "Poppins",
          }}
          className="appmodal-description"
        >
          {description}
        </p>
      )}
      {subDescription && (
        <p style={{ margin: 0, fontWeight: 600, color: "unset", fontSize: 14 }}>
          {subDescription}
        </p>
      )}

      {children}
    </Modal>
  );
};

export default AppModal;
